import { v4 as uuid } from 'uuid'

interface IQuestionChoice {
  id: string | number;
  order: number;
  question: number;
  text_value?: string;
  header?: string;
  help_text?: string;
  number_value?: number;
}

// Values example:
// header: "Poor"
// help_text: ""
// id: 14
// number_value: null
// order: 0
// question: 261
// text_value: "Poor"

class QuestionColumn {
  constructor(
    {
      id,
      number_value,
      order,
      question,
      text_value,
      help_text,
    }: IQuestionChoice,
    isNew = true
  ) {
    this.id = id ?? uuid()
    this.number_value = number_value ?? null
    this.order = order || 0
    this.question = question
    this.text_value = text_value
    this.header = text_value
    this.help_text = help_text
    this.isNew = isNew
  }
}

export default QuestionColumn
